/*
 * Actiunile din bara de sus a meniului mobil (cautare / cont / cos / limba).
 *
 * Principiu: NU dublam logica drawerelor. Butonul inchide meniul burger,
 * apoi deleaga click-ul catre trigger-ul canonic deja existent in header
 * (.wt-header__search-trigger, .wt-cart__trigger). Astfel comportamentul
 * ramane identic cu cel din headerul inchis, cu o singura sursa de adevar.
 */
(function () {
  "use strict";

  var MENU_ID = "megamenu-mobile-container";
  var CLOSE_ID = "mobile_menu_close";

  function closeMobileMenu() {
    var closeBtn = document.getElementById(CLOSE_ID);
    if (closeBtn) {
      // Reutilizeaza resetMobile() din megamenu.js: inchide + reseteaza nivelul.
      closeBtn.click();
      return;
    }
    var menu = document.getElementById(MENU_ID);
    if (menu) {
      menu.classList.add("tw-hidden");
      document.body.style.overflow = "auto";
    }
  }

  function init() {
    var menu = document.getElementById(MENU_ID);
    if (!menu) return;

    menu.addEventListener("click", function (event) {
      var action = event.target.closest("[data-mobile-menu-action]");
      if (!action || !menu.contains(action)) return;

      var selector = action.getAttribute("data-mobile-menu-action");
      var target = document.querySelector(selector);
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      closeMobileMenu();

      // Lasam animatia de inchidere sa porneasca inainte de a deschide drawerul.
      window.setTimeout(function () {
        target.click();
      }, 50);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
